import { DeployStage, Env } from "../../env";

export const LOGIN_REDIRECT_PARAM = "redirect";

// Only Data Explorer may receive a signed-in user back. Any other target would turn the login page
// into an open redirect, so the origin is matched exactly, per stage.
const LOGIN_REDIRECT_ORIGINS: Readonly<Record<DeployStage, readonly string[]>> = {
  [DeployStage.Test]: ["https://develop.explorer.pomelo.click"],
  [DeployStage.Develop]: ["https://develop.explorer.pomelo.click"],
  [DeployStage.Staging]: ["https://staging.explorer.pomelo.click"],
  [DeployStage.Production]: ["https://release.explorer.labfront.com"],
};

/** The allowed return URL carried by `search`, or null when absent or not allowed. */
export const readLoginRedirect = (search: string, stage?: DeployStage): string | null => {
  const value = new URLSearchParams(search).get(LOGIN_REDIRECT_PARAM);
  if (!value) return null;

  let url: URL;
  try {
    url = new URL(value);
  } catch {
    return null;
  }

  const allowedOrigins = LOGIN_REDIRECT_ORIGINS[stage ?? Env.shared.deployStage] ?? [];
  return allowedOrigins.includes(url.origin) ? url.href : null;
};

/** `path` with the return URL carried along, so a multi-step sign-in can still honour it. */
export const withLoginRedirect = (path: string, redirect: string | null): string => {
  if (!redirect) return path;

  const [pathname, query = ""] = path.split("?");
  const params = new URLSearchParams(query);
  params.set(LOGIN_REDIRECT_PARAM, redirect);
  return `${pathname}?${params.toString()}`;
};

// its own export so tests can stand in for a navigation jsdom does not implement
export const leaveForLoginRedirect = (redirect: string) => window.location.assign(redirect);
